import {formatString} from '@optimaxdev/utils';

export const CART_BUTTON = {
    action: formatString('{{action}}'),
    category: formatString('Cart - {{version}}'),
    label: formatString('{{label}}'),
    name: 'Cart',
};

export const CART_PROMOTION_BANNER = {
    action: formatString('Promotion Banner - {{action}}'),
    category: formatString('Cart - {{version}}'),
    label: formatString('{{label}}'),
    name: 'Cart',
};

export const CART_SECTION = {
    action: formatString('{{section}} Section'),
    category: formatString('Cart - {{version}}'),
    label: formatString('{{label}}'),
    name: 'Cart',
};

export const CART_CTA = {
    action: formatString('{{action}}'),
    category: formatString('Cart - {{version}}'),
    label: formatString('CTA - {{label}}'),
    name: 'Cart',
};

export const CART_ONE_DAY_SHIPPING = {
    action: '1BD Shipping',
    category: formatString('Cart - {{version}}'),
    label: formatString('{{label}}'),
    name: 'Cart',
};

export const CART_EMPTY_CART = {
    action: 'Empty Cart',
    category: formatString('Cart - {{version}}'),
    label: formatString('{{label}}'),
    name: 'Cart',
};

export const CART_CART_KLARNA_POPUP = {
    action: formatString('{{action}}'),
    category: formatString('Cart - {{version}}'),
    label: formatString('{{label}}'),
    name: 'Cart',
};

export const CART_PAY_LATER_LEARN_MORE = {
    action: 'Pay Over Time',
    category: formatString('Cart - {{version}}'),
    label: formatString('{{label}} - Learn More'),
    name: 'Cart',
};
